import { IModel, Model, ModelRecord } from '@common/models/Model';
import { defaultTo } from 'lodash';

export interface IPrescriptionPharmacyModel extends IModel {
  prescriptionPharmacyId: number;
  name: string;
  eventTypeNote: string;
}

export class PrescriptionPharmacyModel
  extends Model
  implements ModelRecord<IPrescriptionPharmacyModel>
{
  prescriptionPharmacyId: number;
  name: string;
  eventTypeNote: string;

  constructor(params?: Partial<IPrescriptionPharmacyModel>) {
    super(params);
    this.prescriptionPharmacyId = defaultTo(params?.prescriptionPharmacyId, 0);
    this.name = defaultTo(params?.name, '');
    this.eventTypeNote = defaultTo(params?.eventTypeNote, '');
  }
}
